import { reducer } from './newCollection';
import { initialStateBase } from './newCollection';
import { getType } from './helpers/typeModifier.js';
import { __BUSINESS_USER, __ADDITIONAL_NON_EDIT_FIELDS, __GST_FIELD_NAME } from 'Constants/monetizers';

export const urls = {
    saveBilling: '/api/monetizer/billing',
    billing: '/api/v2/monetizer/billing',
    purchase: '/api/monetizer/purchase',
    purchaseV3: '/api/v3/monetizer/purchase',
    purchaseMulti: '/api/v2/monetizer/purchase',
    invoices: '/api/monetizer/invoices',
    orders: '/api/monetizer/orders/documents',
    getPackagesList: '/api/catalog/packages',
    getPackagesListById: id => `/api/v2/monetizer/packages/${id}`,
    activateAdWithFreeLimit: adId => `/api/activateWithFreeLimit/${adId}`,
    consumablePackages: '/api/monetization/consumption/getConsumablePackages',
    userPackages: userId => `/api/monetization/consumption/getUserPackages/${userId}`,
    getGSTDetails: '/api/monetizer/fetchTaxDetails',
    getActivePackage: userId => `/api/monetization/consumption/getUserPackages/${userId}/active`,
    renewPackages: '/api/packages',
    getCouponAgainstPackage: '/api/coupons/packages/search',
    monetDraftMultiPackage: '/api/v1/monetizer/cart',
    monetDraftSinglePackage: '/api/v2/monetizer/cart'
};

const initialState = {
    ...initialStateBase,
    metadataKey: 'monetizers',
    validation: {},
    errorMessage: {}
};

const transformBillingInfo = response => {
    const { section: sections, mandatoryFields, mandatoryRules, nonEditRules: billingNonEditRules = [] } = response.data;
    const { data: savedSections = [] } = response.metadata;
    // isGstPresent: flag to check whether GST details already submitted to backend or not
    // To-do: Ask backend side to provide this flag inside GET billing info API
    const isGstPresent = savedSections.some(section => (section.id === __GST_FIELD_NAME && !!section.value));
    const nonEditRules = isGstPresent ? billingNonEditRules.map(rules => {
        const { filterValue, fields } = rules;

        if (filterValue === __BUSINESS_USER) {
            // logic to add "type" and "vatNumber" as non edit fields for "business" user if gst details already present on backend
            // To-do: Ask backend to handle this logic
            return { ...rules, fields: fields.concat(__ADDITIONAL_NON_EDIT_FIELDS) };
        }
        return rules;
    }) : billingNonEditRules;

    return {
        data: {
            mandatoryRules,
            mandatoryFields,
            nonEditRules,
            sections: sections.map(section => {
                return {
                    ...section,
                    fields: section.fields.map(field => {
                        const findValue = savedSections && savedSections.find(saved => saved.id === field.id);
                        const value = findValue && findValue.value ? findValue.value : '';

                        return { ...field, value };
                    })
                };
            }),
            isGstPresent,
            saved: false
        }
    };
};

const transformGstInfo = (state, response) => {
    const data = response.data;

    return {
        data: {
            addressDetails: data[0]
        }
    };
};

const transformGetData = (_state, url, response) => {
    const urlWithoutParams = url.split('?')[0];

    switch (urlWithoutParams) {
        case urls.invoices:
            response = { data: { list: response.data }};
            break;
        case urls.billing:
            response = transformBillingInfo(response);
            break;
        case urls.getPackagesList:
            response = { data: response.data };
            break;
        case urls.getGSTDetails:
            response = transformGstInfo(_state, response);
            break;
        default:
            response = { data: response.data };
            break;
    }
    return response;
};

const transformPostData = (state, url, response) => {
    const urlWithoutParams = url.split('?')[0];
    const type = getType('MONETIZERS', url);

    if (urlWithoutParams === urls.saveBilling) {
        state.validation[type] = {};
        response = { data: { ...state.collections[type], saved: true }};
    }

    return response;
};

const transformErrorData = (state, action) => {
    const { url, data: response } = action;
    const urlWithoutParams = url.split('?')[0];
    const type = getType('MONETIZERS', url);

    if ([`${urls.saveBilling}`, `${urls.getGSTDetails}`].includes(urlWithoutParams)) {
        return reducer({
            ...state,
            validation: {
                [type]: response.details && response.details.errors || true
            },
            errorMessage: {
                [type]: response.message
            }
        }, action, 'MONETIZERS');
    }

    return reducer(state, action, 'MONETIZERS');
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'RECEIVE_MONETIZERS':
            action.data = transformGetData(state, action.url, action.data);
            return reducer(state, action, 'MONETIZERS');

        case 'RESET_PURCHASE': {
            const newState = { ...state };
            const type = getType('MONETIZERS', urls.purchase);

            newState.collections[type] = action.data;

            return reducer(newState, action, 'MONETIZERS');
        }
        case 'RESPONSE_POST_MONETIZERS':
            action.data = transformPostData(state, action.url, action.data);
            return reducer(state, action, 'MONETIZERS');
        case 'ERROR_POST_MONETIZERS':
        case 'ERROR_MONETIZERS':
            return transformErrorData(state, action);
        case 'SAVE_GSTIN':
            return { ...state, gstin: action.data };
        default:
            return reducer(state, action, 'MONETIZERS');
    }
};
